import { Vue, Component, Watch } from 'vue-property-decorator';

@Component
export default class focusMixin extends Vue {
  public modalName = '';

  /**
   * Opt-in: when true, opening the modal focuses `#${modalName}-btnConfirm` and applies
   * the keyboard focus ring (see focusElement). Default false — no auto-focus on open.
   * Use sparingly: e.g. `ConfirmationDialog` (global confirm) and destructive one-step
   * confirmations like `StoreDeletionModal`. Most modals (forms, notifications, etc.) should
   * leave this false so the primary action does not look pre-selected.
   */
  protected focusConfirmButtonOnOpen = false;

  @Watch('show', { immediate: true })
  private async focusConfirmButtonOnModalOpen(val: boolean) {
    if (!val || !this.focusConfirmButtonOnOpen) return;
    await this.$nextTick();
    this.focusElement(`${this.modalName}-btnConfirm`);
  }

  public focusElement = (elementId: string, event?: KeyboardEvent): void => {
    if (event?.target instanceof HTMLInputElement) {
      return;
    }

    const element = document.getElementById(elementId);
    if (!element) return;

    // Add focus ring class to the element
    element.classList.add('focus-ring');

    // Set up one-time blur listener to remove the class when focus is lost
    element.addEventListener('blur', function onBlur() {
      element.classList.remove('focus-ring');
      element.removeEventListener('blur', onBlur);
    });

    element.focus();
  }

  created(): void {
    this.modalName = this.$options.name ?? '';
  }
}
